<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'DynamicDomainNameList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              Dynamic Domain Name
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Dynamic Domain Name</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="DynamicDomainName">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div v-if="organizationId == 1" class="form-group required">
                    <label class="control-label">Audra</label>
                    <input
                      v-if="is_edit"
                      type="text"
                      v-model="pre.audraName[value.accountId]"
                      id="accountId"
                      class="form-control accountId"
                      name="accountId"
                      readonly
                    />
                    <multiselect
                      v-else
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('accountId')">
                      {{ errors.first("accountId") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Enable</label>
                    <div class="d-flex align-items-center">
                      <label class="radio mr-3">
                        <input
                          type="radio"
                          id="is_enable"
                          name="is_enable"
                          v-model="value.is_enable"
                          class=""
                          value="1"
                          v-bind:class="{
                            'has-error': errors.has('is_enable'),
                          }"
                          v-validate="'required'"
                        />
                        <span class="radio-mark"></span>
                        Yes
                      </label>
                      <label class="radio">
                        <input
                          type="radio"
                          id="is_enable"
                          name="is_enable"
                          v-model="value.is_enable"
                          class=""
                          value="0"
                          v-bind:class="{
                            'has-error': errors.has('is_enable'),
                          }"
                          v-validate="'required'"
                        />
                        <span class="radio-mark"></span>
                        No
                      </label>
                    </div>

                    <div class="help text-danger" v-show="errors.has('is_enable')">
                      {{ errors.first("is_enable") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Service Provider</label>
                    <select
                      class="form-control"
                      style="width: 100%"
                      v-bind:class="{
                        'has-error': errors.has('service_provider'),
                      }"
                      v-validate="'required'"
                      name="service_provider"
                      v-model="value.service_provider"
                      id="service_provider"
                    >
                      <option value="no-ip.com">no-ip.com</option>
                    </select>
                    <div class="help text-danger" v-show="errors.has('service_provider')">
                      {{ errors.first("service_provider") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Domain Name</label>
                    <input
                      type="text"
                      id="domain_name"
                      name="domain_name"
                      v-bind:class="{ 'has-error': errors.has('domain_name') }"
                      v-validate="{
                        required: true,
                        regex: /^(?!\-)(?:(?:[a-zA-Z\d][a-zA-Z\d\-]{0,61})?[a-zA-Z\d]\.){1,126}(?!\d+)[a-zA-Z\d]{1,63}$/,
                      }"
                      v-model="value.domain_name"
                      class="form-control domain_name"
                      placeholder="Input Domain Name. Example: demo-poc.ddns.net"
                    />
                    <div class="help text-danger" v-show="errors.has('domain_name')">
                      {{ `The Domain name required in proper domain format.` }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">User Name</label>
                    <input
                      type="text"
                      id="user_name"
                      name="user_name"
                      v-bind:class="{ 'has-error': errors.has('user_name') }"
                      v-validate="'required'"
                      v-model="value.user_name"
                      class="form-control user_name"
                      placeholder="User Name"
                    />
                    <div class="help text-danger" v-show="errors.has('user_name')">
                      {{ errors.first("user_name") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Password</label>
                    <input
                      type="text"
                      id="user_password"
                      name="user_password"
                      v-bind:class="{
                        'has-error': errors.has('user_password'),
                      }"
                      v-validate="'required'"
                      v-model="value.user_password"
                      class="form-control user_password"
                      placeholder="Password"
                    />
                    <div class="help text-danger" v-show="errors.has('user_password')">
                      {{ errors.first("user_password") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "DynamicDomainNameForm",
  metaInfo: {
    title: "Dynamic Domain Name | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
      is_enable: 1,
    },
    pre: {
      is_enable: 1,
      audraName: [],
    },
  }),
  methods: {
    isEnableOptions: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-dropdown-options/1")
          .then((response) => {
            resolve(response.data);
            // return response.data;
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },

    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/dynamic_domain_names";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/dynamic_domain_names/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "DynamicDomainNameList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/dynamic_domain_names/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });
      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
      }
      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>
